/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'

import type { CryptoRedemptionRequest, CryptoRedemptionResponse } from '../models'

import redemptionsRedemptionOptionsCryptoRedeemCreateMutator from '../../client'

/**
 * Redeem Edge points for cryptocurrency. Users must have unlocked additional redemption options. The request requires a valid crypto option ID, wallet address, and Edge amount. Upon successful redemption, a CryptoRedemption record is created for manual fulfillment tracking.
 * @summary Redeem Cryptocurrency
 */
export const redemptionsRedemptionOptionsCryptoRedeemCreate = (
  cryptoRedemptionRequest: CryptoRedemptionRequest,
  signal?: AbortSignal,
) => {
  return redemptionsRedemptionOptionsCryptoRedeemCreateMutator<CryptoRedemptionResponse>({
    url: `/api/v1/redemptions/redemption-options/crypto/redeem/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: cryptoRedemptionRequest,
    signal,
  })
}

export const getRedemptionsRedemptionOptionsCryptoRedeemCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoRedeemCreate>>,
    TError,
    { data: CryptoRedemptionRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoRedeemCreate>>,
  TError,
  { data: CryptoRedemptionRequest },
  TContext
> => {
  const mutationKey = ['redemptionsRedemptionOptionsCryptoRedeemCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoRedeemCreate>>,
    { data: CryptoRedemptionRequest }
  > = (props) => {
    const { data } = props ?? {}

    return redemptionsRedemptionOptionsCryptoRedeemCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type RedemptionsRedemptionOptionsCryptoRedeemCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoRedeemCreate>>
>
export type RedemptionsRedemptionOptionsCryptoRedeemCreateMutationBody = CryptoRedemptionRequest
export type RedemptionsRedemptionOptionsCryptoRedeemCreateMutationError = void

/**
 * @summary Redeem Cryptocurrency
 */
export const useRedemptionsRedemptionOptionsCryptoRedeemCreate = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoRedeemCreate>>,
    TError,
    { data: CryptoRedemptionRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsCryptoRedeemCreate>>,
  TError,
  { data: CryptoRedemptionRequest },
  TContext
> => {
  const mutationOptions = getRedemptionsRedemptionOptionsCryptoRedeemCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
